var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-full-screen-container',[_c('div',{staticClass:"rfirfa"},[_c('div',{staticClass:"rfirfa_container"},[_c('div',{staticClass:"rfirfa_one"},[_c('rfi')],1),_vm._v(" "),_c('div',{staticClass:"rfirfa_one"},[_c('rfa')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88a7e75c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/outside/rfirfa/main.vue
// module id = null
// module chunks = 